var _clipPath, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 19,
    viewBox: "0 0 19 19",
    width: 19,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h19v19h-19z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.5 0c5.2465 0 9.5 4.25353 9.5 9.5 0 5.2465-4.2537 9.5-9.5 9.5-5.24628 0-9.5-4.2524-9.5-9.5 0-5.24761 4.25296-9.5 9.5-9.5z",
    fill: "#53ae94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.6724 8.23422v-1.41323h3.2317v-2.15327h-8.80001v2.15327h3.23209v1.41208c-2.62675.12065-4.6018.64088-4.6018 1.26408 0 .62315 1.976 1.14345 4.6018 1.26485v4.5267h2.33702v-4.5271c2.622-.121 4.593-.6409 4.593-1.2635 0-.62264-1.971-1.14248-4.593-1.26351m0 2.14361v-.0012c-.066.0042-.4047.0245-1.15902.0245-.60306 0-1.02733-.0171-1.17686-.0248v.0019c-2.32067-.1028-4.0529-.50697-4.0529-.99052s1.73242-.88711 4.0529-.99009v1.57795c.152.01045.58671.03606 1.18674.03606.72064 0 1.08304-.02997 1.14954-.03606v-1.57795c2.3161.10317 4.0443.50768 4.0443.98952s-1.729.88659-4.0443.98969",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.751316064331f9a7dd5058789e123fdf.svg";
export { ForwardRef as ReactComponent };